document.addEventListener("DOMContentLoaded", function() {
  const scrollContainers = document.querySelectorAll(".scroll-container");

  scrollContainers.forEach(container => {
    // перевірка чи вміст більший за ширину
    if (container.scrollWidth > container.clientWidth) {
      container.classList.add("is-draggable");
    }

    let isDown = false;
    let startX;
    let scrollLeft;

    container.addEventListener("mousedown", (e) => {
      if (!container.classList.contains("is-draggable")) return;
      isDown = true;
      container.classList.add("active");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener("mouseleave", () => {
      isDown = false;
      container.classList.remove("active");
    });

    container.addEventListener("mouseup", () => {
      isDown = false;
      container.classList.remove("active");
    });

    container.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 1; // множник швидкості
      container.scrollLeft = scrollLeft - walk;
    });

    // можна ще слухати resize, щоб перевіряти при зміні ширини
    window.addEventListener("resize", () => {
      if (container.scrollWidth > container.clientWidth) {
        container.classList.add("is-draggable");
      } else {
        container.classList.remove("is-draggable");
      }
    });
  });
});
